import { useState } from 'react';
import { Box, Grid, ToggleButton, MuiToggleButtonGroup, Typography } from 'components/ui';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client/react';
import { WhiteCard } from 'components/styles_components/card';
import { DividerContainer } from 'components/styles_components/container';
import { CardOptionTypography } from 'components/styles_components/typography';
import BillingQuery from 'queries/space/billing';
import PlanShow from 'components/space/plan/show';
import Usage from 'components/space/plan/usage';
import BillingDetailsShow from 'components/space/billing_details/show';
import PlanExpiration from 'components/space/plan/expiration';
import LoaderContainer from 'components/layout/loader_container';

const Plan = () => {
  const setError = useError();
  const [billingIntervalType, setBillingIntervalType] = useState('month');
  const {
    data = { space: { activePlan: { placesLimit: 1 } }, plans: { plans: [] } },
    loading,
    refetch,
  } = useQuery(BillingQuery, {
    variables: { billingIntervalType },
    onError: () => {
      setError('error.billing.show');
    },
  });

  const handleBillingIntervalChange = (_event, nextValue) => {
    if (nextValue === null || nextValue === billingIntervalType) {
      return;
    }
    setBillingIntervalType(nextValue);
  };

  return (
    <WhiteCard>
      <LoaderContainer loading={loading} wrap={false}>
        <Typography variant="h6">
          <FormattedMessage id="plan.current" /> {data.space.activePlan.name}
        </Typography>
        <PlanExpiration endDate={data.space.activePlanEndDate} />
        <DividerContainer />
        <Grid container spacing={6} alignItems="stretch">
          <Grid size={{ xs: 12, md: 6 }}>
            <CardOptionTypography>
              <FormattedMessage id="plan.current.usage" />
            </CardOptionTypography>
            <Usage
              label={<FormattedMessage id="plan.used.places" />}
              value={data.space.placesTotal}
              valueBuffer={data.space.activePlan.placesLimit}
            />
            <Usage
              label={<FormattedMessage id="plan.used.inspection_subjects" />}
              value={data.space.inspectionSubjectsTotal}
              valueBuffer={data.space.activePlan.inspectionSubjectsLimit}
            />
            <Usage
              label={<FormattedMessage id="plan.used.inspections" />}
              value={data.space.pendingInspectionsTotal}
              valueBuffer={data.space.activePlan.inspectionsLimit}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <BillingDetailsShow billingDetails={data.space.billingDetails} refetch={refetch} />
          </Grid>
        </Grid>
        <DividerContainer />
        <CardOptionTypography>
          <FormattedMessage id="plan.change" />
        </CardOptionTypography>
        <DividerContainer />
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <MuiToggleButtonGroup
            exclusive
            size="small"
            value={billingIntervalType}
            onChange={handleBillingIntervalChange}
          >
            <ToggleButton value="month">
              <FormattedMessage id="plan.period.month" />
            </ToggleButton>
            <ToggleButton value="year">
              <FormattedMessage id="plan.period.year" />
            </ToggleButton>
          </MuiToggleButtonGroup>
        </Box>
        <Grid container spacing={2} alignItems="stretch">
          {data.plans.plans.map((plan) => (
            <PlanShow
              key={plan.id}
              plan={plan}
              active={data.space.activePlan.id === plan.id}
              billingDetails={data.space.billingDetails}
            />
          ))}
        </Grid>
      </LoaderContainer>
    </WhiteCard>
  );
};

export default Plan;
